import React from 'react';
import { COLORS } from '../../../constants/colors';

const PlayArrow = ({ color = COLORS.black }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g stroke={color}>
        <g>
          <g>
            <g transform="translate(-288 -4055) translate(288 3892) translate(0 161) translate(0 2)">
              <circle cx="11.827" cy="11.827" r="11.327" />
              <path strokeLinecap="square" d="M14.515 11.827L10.483 14.246 10.483 9.408z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PlayArrow;
